/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { Component } from 'react';
import browser from '@openclassrooms/utils/browser';

export class AutocompleteSuggestions extends Component {
  static defaultProps = {
    id: null,
    suggestionRenderer: null,
    suggestions: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      highlightedSuggestion: {},
      isClosed: false,
    };
  }

  componentDidMount() {
    browser.window.addEventListener('keydown', this.handleGlobalKeydown);
  }

  componentWillUnmount() {
    browser.window.removeEventListener('keydown', this.handleGlobalKeydown);
  }

  getNextSuggestion() {
    const { suggestions } = this.props;
    const { highlightedSuggestion } = this.state;

    const defaultSuggestion = suggestions[0] || {};

    if (!highlightedSuggestion.id) {
      return defaultSuggestion;
    }

    const nextIndex = [suggestions.indexOf(highlightedSuggestion) + 1];

    return suggestions[nextIndex] || defaultSuggestion;
  }

  getPreviousSuggestion() {
    const { suggestions } = this.props;
    const { highlightedSuggestion } = this.state;

    const lastIndex = suggestions.length - 1;
    const defaultSuggestion = suggestions[lastIndex] || {};

    if (!highlightedSuggestion.id) {
      return defaultSuggestion;
    }

    const previousIndex = suggestions.indexOf(highlightedSuggestion) - 1;

    return suggestions[previousIndex] || defaultSuggestion;
  }

  getSelectSuggestionFunc() {
    const { onSelect } = this.props;
    const { highlightedSuggestion } = this.state;

    return () => {
      if (!highlightedSuggestion.id) {
        return;
      }

      onSelect(highlightedSuggestion);

      this.setState(() => ({
        highlightedSuggestion: {},
      }));
    };
  }

  getHighlightSuggestionFunc(suggestion) {
    return () => {
      this.setState(() => ({
        highlightedSuggestion: suggestion,
      }));
    };
  }

  getNormalizeSuggestionFunc(suggestion) {
    return () => {
      this.setState((prevState) => {
        if (!this.isSuggestionHighlighted(suggestion)) {
          return prevState;
        }

        return {
          highlightedSuggestion: {},
        };
      });
    };
  }

  handleGlobalKeydown = (e) => {
    let { highlightedSuggestion, isClosed } = this.state;

    switch (e.key) {
      case 'ArrowLeft':
        break;

      case 'ArrowRight':
        break;

      case 'ArrowDown':
        highlightedSuggestion = this.getNextSuggestion();
        e.preventDefault();
        e.stopPropagation();
        break;

      case 'ArrowUp':
        highlightedSuggestion = this.getPreviousSuggestion();
        e.preventDefault();
        e.stopPropagation();
        break;

      case 'Enter':
        this.getSelectSuggestionFunc()();
        e.preventDefault();
        e.stopPropagation();
        break;

      case 'Escape':
        isClosed = true;
        e.preventDefault();
        e.stopPropagation();
        break;

      default:
        isClosed = false;
        break;
    }

    this.setState(() => ({ highlightedSuggestion, isClosed }));
  };

  isSuggestionHighlighted = (suggestion = {}) => {
    const { highlightedSuggestion } = this.state;
    return highlightedSuggestion.id === suggestion.id;
  };

  renderSuggestions() {
    const preventEvent = (e) => e.preventDefault();
    const { suggestions, suggestionRenderer } = this.props;

    return suggestions.map((suggestion) => {
      const highlithedClassname = 'autocompleteSuggestions__listItem--highlighted';
      const highlighted = this.isSuggestionHighlighted(suggestion) ? highlithedClassname : '';

      return (
        <li
          className={`autocompleteSuggestions__listItem ${highlighted}`}
          key={suggestion.id}
          onClick={this.getSelectSuggestionFunc(suggestion)}
          onMouseDown={preventEvent}
          onMouseMove={this.getHighlightSuggestionFunc(suggestion)}
          onMouseLeave={this.getNormalizeSuggestionFunc(suggestion)}
        >
          {suggestionRenderer ? suggestionRenderer(suggestion) : suggestion.value}
        </li>
      );
    });
  }

  render() {
    const { id, suggestions } = this.props;
    const { isClosed } = this.state;

    if (isClosed || !suggestions.length) {
      return null;
    }

    return (
      <nav className="autocompleteSuggestions">
        <ul className="autocompleteSuggestions__list" id={id}>
          {this.renderSuggestions()}
        </ul>
      </nav>
    );
  }
}

export default AutocompleteSuggestions;
